import { IoLockClosedOutline } from "react-icons/io5";
import { BsShield, BsDatabaseCheck } from "react-icons/bs";
import { BiUniversalAccess } from "react-icons/bi";
import { getAccessToken } from "../../storage/storage";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";

export default function LodgifyConnection() {
  const token = getAccessToken();
  const { case: caseParam } = useParams();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const Navigate = useNavigate();
  const [apiKey, setApiKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const PropertyInfo = JSON.parse(sessionStorage.getItem("PropertyData"));
  const handleAuthorize = async () => {
    if (!apiKey.trim()) {
      setError("Please enter an API key");
      return;
    }

    setIsLoading(true);
    setError("");
    let response;
    try {
      {
        caseParam === "2" ? (
          response = await axios.post(
            `${BASE_URL}/api/properties/property-list/`,
            { ApiKey: apiKey },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )

        ) : (
          response = await axios.post(
            `${BASE_URL}/api/add-api-key/`,
            { api_key: apiKey },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ))
      }
      ;

      Navigate(caseParam === "2" ? "/lodgify-import-hkproperty" : "/lodgify-import-property", {
        state: {
          lodgifyData: response.data,
          apiKey: apiKey,
        },
      });

    } catch (err) {
      setError(err.response?.data?.message || "Failed to authorize. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6 my-10 bg-white shadow-lg p-6 rounded-lg">
      <h1 className="md:text-xl text-lg font-bold text-[#586989] mb-4">
        Connect HouseKeeper to Lodgify
      </h1>
      <p className="text-gray-600 mb-6 text-start text-sm">
        Authorize secure access to Lodgify account to enable automatic booking synchronization
      </p>

      <div className="border border-[#586989] rounded-md p-2 flex gap-2">
        <span className="ml-0 text-black mt-1"> <BsShield /></span>
        <div className="text-sm text-black text-opacity-50">
          <strong>Secure Authorization Process:</strong>
          <span>
            HouseKeeper uses OAuth 2.0, the industry standard for secure authorization.
            Your Lodgify login credentials are never shared with HouseKeeper. You can revoke access at any time from your Lodgify
            account settings.
          </span>
        </div>
      </div>

      <div className="bg-[#FFF5CE] p-4 rounded-lg shadow">
        <h1 className="md:text-xl text-lg font-bold text-[#586989] mb-4 align-center">
          How We Handle Your Data
        </h1>
        <div className="mb-2">
          <h2 className="text-sm font-semibold flex items-center gap-2">
            <IoLockClosedOutline />
            Secure & Encryption
          </h2>
          <p className="text-sm ">All data is transmitted using TLS 1.3 encryption and stored securely in compliance with industry standards.</p>
        </div>
        <div className="mb-2">
          <h2 className="text-sm font-semibold flex items-center gap-2">
            <BsShield />
            Privacy Compliance
          </h2>
          <p className="text-sm ">Guest data is handled in full compliance with GDPR and other privacy regulations.</p>
        </div>
        <div className="mb-2">
          <h2 className="text-sm font-semibold flex items-center gap-2">
            <BsDatabaseCheck />
            Data Usage
          </h2>
          <p className="text-sm "> Your data is used solely to provide cleaning management services and improve platform functionality.</p>
        </div>
        <div className="mb-2">
          <h2 className="text-sm font-semibold flex items-center gap-2">
            <BiUniversalAccess />
            Access Control
          </h2>
          <p className="text-sm ">You can revoke HouseKeeper's access to your Lodgify account at any time from your Lodgify settings.</p>
        </div>
      </div>

      <div className="flex space-x-2 mt-2">
        <input
          type="text"
          placeholder="Enter API Key"
          className="p-2 rounded-md w-full border border-[#586989]"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
        />
        <button
          onClick={handleAuthorize}
          disabled={isLoading}
          className="flex gap-2 bg-[#586989] text-white px-6 py-2 rounded-md disabled:opacity-50"
        >
          {isLoading ? "Authorizing..." : "Authorize"}
        </button>
      </div>

      {error && <p className="text-red-500 mt-2">{error}</p>}

      {/* Loading overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold">Connecting to Lodgify...</p>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mt-4"></div>
          </div>
        </div>
      )}
    </div>
  );
}